import React, { useEffect, useState } from 'react';
import doc from '@/assets/doc.svg';
import '../routes/Dashboard.css';
import { Button } from '@/components/Elements';

const InquiryDetails = () => {
  return (
    <>
      <div className="admin-cards">
        <h4 className="f-18 font-semibold mb-0 request-title border-bottom">View Details</h4>
        <div className="detailed-content">
          <h5 className="f-16 font-semibold text-black details-title mt-4">User Details </h5>
          <div className="prop-agency-details d-flex flex-wrap  gap-3">
            <div className="agency-data-col">
              <p className="gry f-14">First Name</p>
              <p className="text-black font-semibold f-14">Henry</p>
            </div>
            <div className="agency-data-col">
              <p className="gry f-14">last Name</p>
              <p className="text-black font-semibold f-14">Doe</p>
            </div>
            <div className="agency-data-col">
              <p className="gry f-14">Phone Number</p>
              <p className="text-black font-semibold f-14">9455677666</p>
            </div>
            <div className="agency-data-col">
              <p className="gry f-14">Email</p>
              <p className="text-black font-semibold f-14">Henry@yopmail.com</p>
            </div>
            <div className="agency-data-col">
              <p className="gry f-14">Address</p>
              <p className="text-black font-semibold f-14">lorem ipsum</p>
            </div>
          </div>
          <h5 className="f-16 font-semibold text-black details-title mt-4">Property Details </h5>
          <div className="prop-agency-details d-flex flex-wrap  gap-3">
            <div className="agency-data-col">
              <p className="gry f-14">Property Name</p>
              <p className="text-black font-semibold f-14">Mill House </p>
            </div>
            <div className="agency-data-col">
              <p className="gry f-14">House Number</p>
              <p className="text-black font-semibold f-14">55</p>
            </div>
            <div className="agency-data-col">
              <p className="gry f-14">Postal Code </p>
              <p className="text-black font-semibold f-14">2355</p>
            </div>
            <div className="agency-data-col">
              <p className="gry f-14">Property Dimensions</p>
              <p className="text-black font-semibold f-14">446</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default InquiryDetails;
